import waveData from "./waves.json";
import { IState, IwaveData } from "../types";
import { generateFromAbridgedBits, generateAllBits } from "../bitFactory";
import { generateBaseEntity, generateEntity } from "../entityFactory";

const { waves, startingBits } = waveData as IwaveData;

const [waveIndex, actorIndex] = [0, 0];
const pick = { wave: { index: waveIndex, actorIndex }, gambit: null };
const { battleDuration } = waves[waveIndex].actors[actorIndex];

export const emptyState: IState = {
  turn: { global: 0, battle: 0, battleDuration },
  actors: [generateBaseEntity("owl_white")],
  pick,
  screen: { current: "#multiplayer-create", previous: "#title" },
  bits: generateAllBits(),
  board: { points: 0, activeTiles: {} },
  waves: []
};

const initialState: IState = {
  turn: { global: 1, battle: 1, battleDuration },
  actors: [
    generateBaseEntity("owl_white"),
    generateEntity(waves[waveIndex].actors[actorIndex])
  ],
  // we just generated 2 actors, so update pick accordingly
  pick: { ...pick, wave: { index: waveIndex, actorIndex } },
  screen: { current: "#title", previous: "#title" },
  bits: generateFromAbridgedBits(startingBits),
  board: {
    points: 0,
    activeTiles: { whiteMagic0: true, root: true }
  },
  waves
};

export default initialState;
